import { ITableConfig, TableColumnType, UITableColumnCellType } from '@shared/ui';

export const tableConfig: ITableConfig = {
  paginationType: 'server-side',
  columns: [
    {
      type: TableColumnType.Order,
      width: '70px',
    },
    {
      title: 'Внешный id (parkingUid)',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'parking.externalId',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Свободные парковочные места',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'freeSpotsCount',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Время событий',
      name: {
        type: UITableColumnCellType.Date,
        fieldName: 'eventTimestamp',
        format: 'dd.MM.yyyy HH:mm',
      },
      type: TableColumnType.Basic,
    },
  ],
};
